<template>
  <section>
    <div class="ui-paper">
      <div class="sketch" :class="{'animate': isAnimate }"></div>
      <div class="tool tool--pencil" :class="{'animate': isAnimate }"></div>
    </div>
  </section>
</template>

<script>

export default {
  name: 'scene1animation',
  data: function () {
    return {
      isAnimate: false,
    }
  },
  methods: {
    animate() {
      this.isAnimate = !this.isAnimate;
    }
  }
}
</script>

<style lang="scss" scoped>
@import "style";

.sketch {
  background-image: none;
  background-repeat: no-repeat;
  background-size: 90%;
  background-position: center center;
  position: absolute;
  width: 100%;
  height: 100%;

  &.animate {
    animation-name: sketch-paper;
    animation-duration: 5s;
    animation-iteration-count: 1;
    animation-fill-mode: forwards;
  }
}

.ui-paper {
  position: relative;

  // preload images (https://stackoverflow.com/questions/1373142/preloading-css-images)
  &:after {
    position: absolute;
    width: 0;
    height: 0;
    overflow: hidden;
    z-index: -1;
    content: url('~@/assets/img/figure--sketch--step1.svg')
      url('~@/assets/img/figure--sketch--step2.svg')
      url('~@/assets/img/figure--sketch--step3.svg')
      url('~@/assets/img/figure--sketch--step4.svg')
      url('~@/assets/img/figure--sketch--step5.svg')
      url('~@/assets/img/figure--sketch--step6.svg')
      url('~@/assets/img/figure--sketch--step7.svg')
      url('~@/assets/img/figure--sketch.svg');
  }
}

.tool--pencil {
  position: absolute;
  opacity: 0;
  cursor: auto;

  &.animate {
    opacity: 1;
    animation-name: sketch-pencil;
    animation-duration: 5s;
    animation-iteration-count: 1;
    animation-fill-mode: forwards;
  }
}

@keyframes sketch-paper {
  0% {
    background-image: none;
  }
  20% {
    background-image: url('~@/assets/img/figure--sketch--step1.svg');
  }
  30% {
    background-image: url('~@/assets/img/figure--sketch--step2.svg');
  }
  40% {
    background-image: url('~@/assets/img/figure--sketch--step3.svg');
  }
  60% {
    background-image: url('~@/assets/img/figure--sketch--step4.svg');
  }
  80% {
    background-image: url('~@/assets/img/figure--sketch--step5.svg');
  }
  85% {
    background-image: url('~@/assets/img/figure--sketch--step6.svg');
  }
  90% {
    background-image: url('~@/assets/img/figure--sketch--step7.svg');
  }
  100% {
    background-image: url('~@/assets/img/figure--sketch.svg');
  }
}

@keyframes sketch-pencil {
  0% {
    top: 0;
    left: 50%;
  }

  15% {
    top: 15%;
    left: 45%;
  }

  20% {
    top: 7%;
    left: 50%;
  }

  25% {
    top: 7%;
    left: 65%;
  }

  30% {
    top: 89%;
    left: 75%;
  }

  40% {
    top: 50%;
    left: 15%;
  }

  60% {
    top: 35%;
    left: 50%;
  }

  80% {
    top: 55%;
    left: 45%;
  }

  85% {
    top: 65%;
    left: 60%;
  }

  100% {
    top: 90%;
    left: 50%;
  }
}

</style>
